import config from './CognitoUserPool';

export const exchangeCodeForToken = async (code) => {
  try {
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('client_id', config.cognito.CLIENT_ID);
    params.append('redirect_uri', config.cognito.REDIRECT_URI);
    params.append('code', code);

    const response = await fetch(`https://${config.cognito.COGNITO_DOMAIN}.auth.us-east-1.amazoncognito.com/oauth2/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    localStorage.setItem('accessToken', data.access_token);
    localStorage.setItem('idToken', data.id_token);
    localStorage.setItem('refreshToken', data.refresh_token);
    
    return true;
  } catch (error) {
    console.error('Error exchanging code for token:', error);
    return false;
  }
};
